import { render, staticRenderFns } from "./SdkInformation.vue?vue&type=template&id=1a428bdc&"
import script from "./SdkInformation.vue?vue&type=script&lang=js&"
export * from "./SdkInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a428bdc')) {
      api.createRecord('1a428bdc', component.options)
    } else {
      api.reload('1a428bdc', component.options)
    }
    module.hot.accept("./SdkInformation.vue?vue&type=template&id=1a428bdc&", function () {
      api.rerender('1a428bdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Input/SDK/SdkInformation.vue"
export default component.exports